<template>
  <div
    @click="goToAgent"
    :class="[
      agent.hasNewUpdate ? 'bg-dark-grey' : 'bg-pitch-black',
      'px-4 pr-5 pt-3 pb-4 border-b border-total-white-500 flex flex-col items-center w-full cursor-pointer',
    ]"
  >
    <!-- Top Section -->
    <div class="flex w-full justify-between items-center">
      <div class="flex items-center">
        <h3 class="text-lg font-bold text-total-white">
          {{ agent.agent_name || "Unnamed Agent" }}
          <span class="text-total-white-800 text-sm ml-1">
            ( {{ agent.provider_name }} )
          </span>
        </h3>
        <span
          v-if="agent.is_default"
          class="ml-2 text-xs font-semibold whitespace-nowrap text-prime-golden bg-dark-grey rounded-md px-2 py-1"
        >
          default
        </span>
      </div>
    </div>

    <!-- Bottom Section -->
    <div
      :class="[
        agent.hasNewUpdate ? 'bg-dark-grey' : 'bg-pitch-black',
        'rounded-lg shadow-md mt-2 mb-1  flex justify-between items-center w-full',
      ]"
    >
      <!-- Left Details -->
      <div class="text-left">
        <p class="text-sm text-total-white-800">
          <span class="font-semibold mr-1">Agent ID:</span>
          <span class="text-sm">{{ agent.provider_agent_id || "Not Assigned" }}</span>
        </p>
        <p class="text-sm mt-2 text-total-white-800">
          last updated at
          {{ agent.date_created ? `${parseDate(agent.date_created)}` : "N/A" }}
        </p>
      </div>

      <!-- Right Chevron Icon -->
      <div class="text-prime-golden flex flex-col items-end mt-3">
        <img
          src="@/assets/images/right-chevron.svg"
          alt="Right Chevron"
          width="16"
          height="16"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { parseDate } from "@/misc/util";

// Props
const props = defineProps({
  agent: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

// Navigation Handler
const goToAgent = () => {
  router.push({
    name: "AgentViewPage", // Ensure this matches your route name in the router
    params: { id: props.agent?.id }, // Pass the agent ID as a parameter
  });
};
</script>

<style scoped>
/* Add scoped styles here if needed */
</style>
